
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36 21h-9v-9a2 2 0 00-2-2h-2a2 2 0 00-2 2v9h-9a2 2 0 00-2 2v2a2 2 0 002 2h9v9a2 2 0 002 2h2a2 2 0 002-2v-9h9a2 2 0 002-2v-2a2 2 0 00-2-2z","fill":"#535353"}})])
          )
        }
      }
    